import edukasi1 from "../assets/edukasi1.png";
import edukasi2 from "../assets/edukasi2.png";
import edukasi3 from "../assets/edukasi3.png";

export default function Edukasi() {
  return (
    <>
      <section className="text-gray-600 body-font">
        <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
          <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center fade-in-up">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              Konsep Dasar 
              <br className="hidden lg:inline-block" /> Empat Sehat Lima Sempurna
            </h1>
            <p className="mb-8 leading-relaxed">
              Konsep Empat Sehat Lima Sempurna adalah panduan dasar pola makan bergizi yang diperkenalkan di Indonesia sejak tahun 1950-an. Konsep ini menekankan pentingnya keseimbangan antara empat kelompok makanan utama, yaitu makanan pokok sebagai sumber karbohidrat, lauk pauk sebagai sumber protein, sayur-sayuran sebagai sumber vitamin dan mineral, serta buah-buahan sebagai sumber serat dan vitamin tambahan. Untuk menyempurnakannya, ditambahkan unsur kelima yaitu susu, yang berperan sebagai pelengkap gizi karena kaya akan kalsium dan protein. Meskipun kini telah disempurnakan menjadi konsep Pola Gizi Seimbang, prinsip Empat Sehat Lima Sempurna tetap menjadi dasar penting dalam membangun kebiasaan makan sehat dan seimbang.
            </p>
          </div>
          <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 fade-in-right-delay">
            <img className="object-cover object-center rounded" alt="hero" src={edukasi1} />
          </div>
        </div>
      </section>

      <section className="text-gray-600 body-font">
        <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
          <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0 fade-in-left">
            <img className="object-cover object-center rounded" alt="hero" src={edukasi2} />
          </div>
          <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center fade-in-up-delay">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              Gizi Seimbang untuk 
              <br className="hidden lg:inline-block" /> Anak Sekolah
            </h1>
            <p className="mb-8 leading-relaxed">
              Gizi seimbang untuk anak sekolah sangat penting untuk mendukung pertumbuhan fisik, perkembangan otak, dan daya konsentrasi saat belajar. Anak-anak membutuhkan asupan energi dan nutrisi yang cukup dari berbagai sumber makanan seperti karbohidrat, protein, lemak sehat, vitamin, dan mineral. Sarapan pagi menjadi kunci agar mereka tidak mudah lelah dan tetap fokus di kelas. Bekal sekolah sebaiknya berisi makanan bergizi seimbang, misalnya nasi atau roti sebagai sumber energi, lauk seperti telur atau ayam untuk protein, sayuran dan buah untuk vitamin, serta air putih untuk menjaga hidrasi. Menghindari makanan cepat saji dan minuman manis berlebihan juga penting agar anak tetap sehat dan berprestasi di sekolah.
            </p>
          </div>
        </div>
      </section>

      <section className="text-gray-600 body-font">
        <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
          <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center fade-in-up">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              Makanan yang Baik untuk 
              <br className="hidden lg:inline-block" /> Kesehatan Otak dan Daya Ingat
            </h1>
            <p className="mb-8 leading-relaxed">
              Makanan yang baik untuk kesehatan otak dan daya ingat berperan penting dalam menjaga fungsi kognitif serta meningkatkan konsentrasi dan fokus. Nutrisi seperti omega-3 dari ikan berlemak (seperti salmon, sarden, dan tuna) membantu memperkuat sel-sel otak dan mendukung komunikasi antar neuron. Buah beri dan sayuran hijau mengandung antioksidan yang melindungi otak dari kerusakan akibat radikal bebas. Kacang-kacangan, biji-bijian, serta alpukat juga kaya akan vitamin E dan lemak sehat yang menjaga aliran darah ke otak tetap lancar. Mengonsumsi makanan bergizi secara teratur, disertai pola hidup sehat dan cukup tidur, dapat membantu meningkatkan daya ingat serta menjaga kesehatan otak dalam jangka panjang.
            </p>
          </div>
          <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 fade-in-right-delay">
            <img className="object-cover object-center rounded" alt="hero" src={edukasi3} />
          </div>
        </div>
      </section>
    </>
  );
}
